<ng-container *ngIf="!scheduledOffersLoading(); else loadingTemplate">
  <div class="com-table com-table-appearance" *ngIf="{ disableConfirmButton: (disableConfirmButton$ | async) } as vm">
    <div class="section">
      <div class="section_container">
        <div class="section-filter">
          <span class="section-filter--show"
            >{{ 'COM.CSV.CSV_REG_NAME' | translate }}:
            <h4>
              {{ displaySelectedReg }}
            </h4></span
          >
        </div>
        <div class="section-in-right section-btns">
          <span [matTooltip]="'COM.FILTERS.EDIT_DISABLED' | translate" [matTooltipDisabled]="applyButtonDisabled()" matTooltipPosition="below">
            <button
              *ngIf="!editModeSignal() && showEditButton()"
              [disabled]="!applyButtonDisabled()"
              scrollToTop
              mat-stroked-button
              color="primary"
              class="round-button section-btns--edit"
              data-cy="schedule-tab-edit-btn"
              (click)="triggerEditMode(true)"
            >
              {{ 'COM.BUTTONS.EDIT' | translate }}
            </button>
          </span>
          <button
            *ngIf="editModeSignal()"
            mat-flat-button
            scrollToHeader
            color="primary"
            [disabled]="!vm.disableConfirmButton"
            [ngClass]="{ 'section-btns--confirm--disabled': !vm.disableConfirmButton }"
            data-cy="schedule-tab-confirm-btn"
            class="round-button section-btns--confirm"
            (click)="save()"
          >
            {{ 'COM.BUTTONS.CONFIRM' | translate }}
          </button>
          <button
            *ngIf="editModeSignal()"
            mat-stroked-button
            scrollToHeader
            color="primary"
            data-cy="schedule-tab-cancel-btn"
            class="round-button section-btns--cancel"
            (click)="cancel()"
          >
            {{ 'COM.BUTTONS.CANCEL' | translate }}
          </button>
        </div>
      </div>

      <div class="section_bulk_offers" *ngIf="editModeSignal()">
        <dr-customer-offers-ui-bulk-offers
          [minDate]="minDate"
          [maxDate]="maxDate"
          [selectedTabOption]="selectedTabSignal()"
          [currentRegViewConfig]="currentRegViewConfig()"
          [showOfferLock]="false"
        ></dr-customer-offers-ui-bulk-offers>
      </div>
    </div>

    <div class="com-table_container">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" [class.mat-mdc-table--spacing]="!editModeSignal()" multiTemplateDataRows>
        <ng-container matColumnDef="offer">
          <th mat-header-cell *matHeaderCellDef class="com-table_container--header-offer-row">{{ 'COM.LABELS.OFFER_NUM' | translate }}</th>
          <td mat-cell *matCellDef="let element" class="com-table_container--offer-column">
            <b>{{ element.index }}</b>
          </td>
        </ng-container>

        <ng-container matColumnDef="time_period">
          <th mat-header-cell *matHeaderCellDef class="com-table_container--header-row">{{ 'COM.LABELS.TIME_FRAME' | translate }}</th>
          <td
            mat-cell
            *matCellDef="let element"
            class="com-table_container--time-column"
            [class.com-table_container--time-column-first-child]="editModeSignal()"
          >
            <b>{{ { inputTime: element.timePeriodKey, timeGap: currentRegViewConfig()!.intervalFrequency } | mapTime }}</b>
            ({{ timezoneAbbr }})
          </td>
        </ng-container>

        <ng-container *ngFor="let column of columns; let i = index" [matColumnDef]="column">
          <th mat-header-cell *matHeaderCellDef class="com-table_container--header-row">
            <ng-container *ngIf="editModeSignal(); else readonlyHeader">
              <mat-checkbox
                color="primary"
                class="checkbox-container--readonly checkbox-container--header"
                (change)="applyBulkOptout(column, $event.checked)"
                >{{ column | weekDay }}</mat-checkbox
              >
            </ng-container>

            <ng-template #readonlyHeader>
              {{ column | weekDay }}
            </ng-template>
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="com-table_container--columns"
            [class.com-table_container--columns-last-child]="editModeSignal()"
          >
            <div [class.com-table_container--columns-readonly]="!editModeSignal()" [class.com-table_container--columns-readonly-last]="i === 6">
              <!-- Readonly mode -->
              <ng-container *ngIf="!editModeSignal(); else editModeRef">
                <div class="td-cell_readonly">
                  <div class="td-cell_readonly-container">
                    <span class="td-cell_readonly-body">
                      <dr-customer-offers-ui-icons *ngIf="element[columns[i]].opt_out" name="logout_outlined"></dr-customer-offers-ui-icons>
                      <dr-customer-offers-ui-icons
                        *ngIf="element[columns[i]].offer_lock"
                        name="shield"
                        fontSet="material-icons-outlined"
                      ></dr-customer-offers-ui-icons>
                    </span>
                    <span class="td-cell_readonly-body">{{ element[columns[i]].value }}</span>
                  </div>
                </div>
              </ng-container>
              <!-- /Readonly mode -->
              <!-- Edit Mode -->
              <ng-template #editModeRef>
                <ng-container>
                  <div class="td-cell--align">
                    <div class="td-cell">
                      <div class="td-cell_custom-input">
                        <input
                          class="td-cell_input"
                          type="number"
                          (wheel)="$event.preventDefault()"
                          [value]="element[columns[i]].value"
                          (keyup)="inputToCellValue(element, $event, column)"
                          validateNumber
                          [max]="currentRegViewConfig()?.maximumValue ?? 0"
                          [min]="currentRegViewConfig()?.minimumValue ?? 0"
                          [untouchedData]="scheduleData!"
                          [timePeriodKey]="element.timePeriodKey"
                          [week]="column"
                          [disabled]="isExternalUser() && !!element[columns[i]]?.offer_lock"
                        />
                      </div>
                    </div>

                    <div class="checkbox-container">
                      <mat-checkbox
                        color="primary"
                        class="checkbox-container--align checkbox-container--readonly"
                        [ngModel]="element[column].opt_out"
                        (change)="inputToCellOptOut(element, $event.checked, column)"
                        [disabled]="isExternalUser() && element[columns[i]].offer_lock"
                        >{{ 'COM.CHECKBOX.OPT_OUT' | translate }}</mat-checkbox
                      >
                      <mat-checkbox
                        *ngIf="!isExternalUser()"
                        color="primary"
                        class="checkbox-container--align checkbox-container--readonly"
                        data-cy="open-tab-offer-locked-checkbox"
                        [ngModel]="element[column].offer_lock"
                        (change)="inputToCellOfferLocked(element, $event.checked, column)"
                        [disabled]="!element[columns[i]].start_date_time"
                        >{{ 'COM.LEGEND.OFFER_LOCK' | translate }}</mat-checkbox
                      >
                    </div>
                  </div>
                </ng-container>
              </ng-template>
              <!-- /Edit Mode -->
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
            <div
              [class.table-element-detail--padding]="editModeSignal()"
              [class.table-element-detail--padding-internal]="editModeSignal() && !isExternalUser()"
              class="table-element-detail"
              [@detailExpand]="editModeSignal() ? 'expanded' : 'collapsed'"
            >
              <div class="expand-container"></div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="table-header-row"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="table-element-row" [class.table-expanded-row]="editModeSignal()"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="table-detail-row"></tr>
      </table>
    </div>

    <div class="com-table_footer">
      <div class="com-table_footer-icon">
        <dr-customer-offers-ui-icons name="shield" fontSet="material-icons-outlined"></dr-customer-offers-ui-icons>
        <span>{{ 'COM.LEGEND.OFFER_LOCK' | translate }}</span>
        <dr-customer-offers-ui-icons name="logout_outlined"></dr-customer-offers-ui-icons>
        <span>{{ 'COM.LEGEND.OPT_OUT' | translate }}</span>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <div class="loading-page">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
